import type { MapDescriptor } from "@webolo/shared";
import { Theme } from "@webolo/shared";

export interface LoadedMap {
  name: string;
  author: string;
  width: number;
  height: number;
  terrain: Uint8Array;
  // Visual theme the server rolled for this room. Used by the renderer to
  // gate effects that should be theme-aware (e.g. FutureWar/Skynet rooms
  // suppress per-player FFA name tints so the enemy roster reads as one
  // uniform Skynet army).
  theme: Theme;
}

export function decodeMap(desc: MapDescriptor): LoadedMap {
  const binary = atob(desc.terrainBase64);
  const terrain = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) terrain[i] = binary.charCodeAt(i);
  return {
    name: desc.name,
    author: desc.author,
    width: desc.width,
    height: desc.height,
    terrain,
    // Older servers may omit `theme`; coerce to Default for safety.
    theme: (desc.theme ?? Theme.Default) as Theme,
  };
}
